<template>
<div id="navbar">
  <el-menu mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <el-dropdown class="avatar-container" trigger="click">
       <div class="avatar-wrapper">
        <img src="@/assets/my.png">
        <span>{{userName}}</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <el-dropdown-item>
          <span @click="dialogVisible = true" style="display:block;">修改密碼</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出登錄</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
     <el-dialog title="修改密碼"
            ref="form"
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            @close="closeDialog()">
      <el-form :model="form"
                ref="form"
                :rules="formRules">
        <el-form-item label="原密碼"
                        prop="oldPassword">
            <el-input type="password"
                      v-model="form.oldPassword"
                      :minlength="6"
                      :maxlength="18"
                      auto-complete="off"
                      placeholder="6-18位數字及字母組合"></el-input>
        </el-form-item>
        <el-form-item label="新密碼"
                        prop="password">
            <el-input type="password"
                      v-model="form.password"
                      :minlength="6"
                      :maxlength="18"
                      auto-complete="off"
                      placeholder="6-18位數字及字母組合"></el-input>
        </el-form-item>
        <el-form-item label="再次輸入"
                      prop="password2">
            <el-input type="password"
                      v-model="form.password2"
                      :minlength="6"
                      :maxlength="18"
                      placeholder="6-18位數字及字母組合"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                    @click="submitChangePwd">確 定</el-button>
      </div>
    </el-dialog>
  </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { changePwd } from '@/api/user.js'
import md5 from 'js-md5'
export default {
  data () {
    const validatePass = (rule, value, callback) => {
      if (value.length <= 5) {
        callback(new Error('密碼最小為6位'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      form: {
        oldPassword: '',
        password: '',
        password2: ''
      },
      formRules: {
        oldPassword: [
          {
            required: true,
            validator: validatePass
          }
        ],
        password: [
          {
            required: true,
            validator: validatePass
          }
        ],
        password2: [
          {
            required: true,
            validator: validatePass
          }
        ]
      }
    }
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ]),
    userName () {
      return localStorage.name
    }
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('ToggleSideBar')
    },
    submitChangePwd () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          try {
            const params = {
              loginId: localStorage.loginId,
              oldPassword: md5(this.form.oldPassword).toUpperCase(),
              password: md5(this.form.password).toUpperCase(),
              password1: md5(this.form.password2).toUpperCase()
            }
            this.loading = true
            changePwd(params).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '修改密碼成功，請重新登錄'
                })
                this.dialogVisible = false
                setInterval(() => {
                  this.logout()
                }, 1000)
              } else {
                this.$message(JSON.stringify(res))
              }
              this.loading = false
            })
          } catch (e) {
            this.loading = false
            this.$message(e)
          }
        } else {
          this.loading = false
          this.$message({
            type: 'warning',
            message: '請正確填寫信息'
          })
        }
      })
    },
    closeDialog () {
      this.$refs['form'].resetFields()
    },
    logout () {
       this.$confirm(`確定要退出登錄嗎？`, {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          location.reload()
          localStorage.clear()
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
#navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      position: relative;
      color: #03b980;
      img{
        width: 25px;
        height: 25px;
        position: relative;
        top: 6px;
        left: -5px;
      }
       span{
        white-space: nowrap;
      }
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 20px;
        font-size: 12px;
      }
    }
  }
  .el-dialog {
      width: 600px !important;
      .el-form-item__error {
        left: 24%;
      }
  }
  .el-input {
    width: 300px !important;
    margin: 0 10px;
  }
  .el-form-item__label {
    width: 120px;
  }
}
</style>
